import React from "react";
import OBHeader from "../pages/onboarding/_components/OBHeader";
import DashboardHeader from "./DashboardHeader";

function PageLayout({ children }) {
  return (
    <div className="ob-page-main-wrapper">
      <DashboardHeader />
      <div className="ob-page-main-body">{children}</div>
    </div>
  );
}

export default PageLayout;
